import type { LegalCopy } from '../types'

export const te: LegalCopy = {
  title: 'న్యాయ సహాయం',
  subtitle: 'సాధారణ న్యాయ సమస్యలు, సులభమైన మాటల్లో. మీ భాషలో వినండి, ప్రతి జవాబుకు ప్రభుత్వ అధికారిక మూలాన్ని చూడండి.',
  helplinesTitle: 'హెల్ప్‌లైన్లు (ఉచిత కాల్స్)',
  helplines: {
    emergency: 'అత్యవసరం: పోలీస్, అగ్నిమాపక, అంబులెన్స్',
    legal_aid: 'ఉచిత న్యాయ సహాయం (NALSA)',
    cyber: 'ఆన్‌లైన్ / UPI మోసం',
    women: 'మహిళా హెల్ప్‌లైన్',
    consumer: 'వినియోగదారుల హెల్ప్‌లైన్'
  },
  faqTitle: 'సాధారణ ప్రశ్నలు',
  searchPlaceholder: 'వెతకండి: FIR, మోసం, RTI, లాయర్…',
  noMatch: 'ఏ ప్రశ్నా సరిపోలలేదు. కింద మీ ప్రశ్న అడగండి.',
  sources: 'అధికారిక మూలం',
  listen: 'వినండి',
  askTitle: 'మీ సొంత న్యాయ ప్రశ్న అడగండి',
  askHint: 'సమ్ఝో ప్రభుత్వ అధికారిక వెబ్‌సైట్ల నుంచి మాత్రమే జవాబు ఇస్తుంది, మూలం లింక్‌తో సహా.',
  starters: ['నాకు ఉచితంగా లాయర్ దొరుకుతారా?', 'ఎవరో నన్ను ఆన్‌లైన్‌లో మోసం చేశారు. నేను ఏం చేయాలి?', 'పోలీసులు నా ఫిర్యాదు రాసుకోవడం లేదు. నేను ఏం చేయగలను?'],
  disclaimer:
    'ఇది అధికారిక మూలాల నుంచి తీసుకున్న సాధారణ సమాచారం, మీ కేసుకు న్యాయ సలహా కాదు. మీ కేసు కోసం లాయర్‌తో మాట్లాడండి — న్యాయ సేవల ప్రాధికార సంస్థ (15100) నుంచి మీకు ఉచితంగా లాయర్ దొరకవచ్చు.',
  topics: {
    get_free_aid: {
      q: 'ఉచిత న్యాయ సహాయం ఎలా పొందాలి?',
      a: 'NALSA ఉచిత హెల్ప్‌లైన్ 15100 కు కాల్ చేయండి. లేదా మీ జిల్లా కోర్టులోని న్యాయ సేవల ప్రాధికార సంస్థ ఆఫీసుకు, లేదా మీ తాలూకా కోర్టులోని న్యాయ సేవల కమిటీకి వెళ్లండి. ఆన్‌లైన్‌లో, పోస్ట్ ద్వారా లేదా ఈ-మెయిల్ ద్వారా కూడా దరఖాస్తు చేయవచ్చు. ఫారం ఉచితం. లాయర్ ఫీజు, కోర్టు ఖర్చులు మీ తరఫున చెల్లిస్తారు.'
    },
    who_free_aid: {
      q: 'ఉచిత లాయర్ ఎవరికి దొరుకుతారు?',
      a: 'చట్టం (న్యాయ సేవల ప్రాధికార సంస్థల చట్టం, సెక్షన్ 12) వీరికి ఉచిత న్యాయ సహాయం ఇస్తుంది: మహిళలు, పిల్లలు, SC/ST వర్గాల వారు, దివ్యాంగులు, పారిశ్రామిక కార్మికులు, మనుషుల అక్రమ రవాణా లేదా వెట్టిచాకిరి బాధితులు, విపత్తులు, కుల దౌర్జన్యాలు లేదా జాతి హింస బాధితులు, కస్టడీలో ఉన్నవారు, మరియు తమ రాష్ట్రం నిర్ణయించిన పరిమితి కంటే తక్కువ వార్షిక ఆదాయం ఉన్నవారు. ఈ ఆదాయ పరిమితి ఒక్కో రాష్ట్రంలో ఒక్కోలా ఉంటుంది.'
    },
    fir: {
      q: 'పోలీసులు నా FIR నమోదు చేయడం లేదు. నేను ఏం చేయగలను?',
      a: 'తీవ్రమైన (కాగ్నిజబుల్) నేరం అయితే, అది వేరే చోట జరిగినా, ఏ పోలీస్ స్టేషన్‌లోనైనా ఫిర్యాదు చేయవచ్చు — దీన్ని జీరో FIR అంటారు. పోలీసులు FIR కాపీని మీకు ఉచితంగా ఇవ్వాలి. వారు నిరాకరిస్తే, మీ ఫిర్యాదును రాతపూర్వకంగా పోస్ట్ ద్వారా పోలీస్ సూపరింటెండెంట్‌కు (SP) పంపండి. SP కూడా ఏమీ చేయకపోతే, అఫిడవిట్ (ప్రమాణ పత్రం) తో మేజిస్ట్రేట్‌కు దరఖాస్తు చేయవచ్చు.'
    },
    cyber_fraud: {
      q: 'ఆన్‌లైన్ లేదా UPI మోసంలో నా డబ్బు పోయింది. నేను ఏం చేయాలి?',
      a: 'వెంటనే 1930 కు కాల్ చేయండి. ఇది ఉచిత జాతీయ సైబర్ క్రైమ్ హెల్ప్‌లైన్ — రాత్రింబవళ్లు పనిచేస్తుంది. త్వరగా ఫిర్యాదు చేస్తే, డబ్బు వేరే చోటికి తరలిపోకుండా ఆపడానికి సహాయపడుతుంది. cybercrime.gov.in లో “Financial Fraud” కింద కూడా ఫిర్యాదు చేయండి.'
    },
    women: {
      q: 'ఒక మహిళ హింస లేదా వేధింపులు ఎదుర్కొంటోంది. ఆమెకు సహాయం ఎక్కడ దొరుకుతుంది?',
      a: 'అత్యవసర పరిస్థితిలో పోలీస్, అగ్నిమాపక లేదా అంబులెన్స్ కోసం 112 కు డయల్ చేయండి. ఉచిత మహిళా హెల్ప్‌లైన్ 181 కు పగలు, రాత్రి ఎప్పుడైనా కాల్ చేయండి. మీ పేరు చెప్పకుండానే మాట్లాడవచ్చు. ఇది మిమ్మల్ని పోలీసులు, వన్ స్టాప్ సెంటర్, ఆసుపత్రి లేదా న్యాయ సహాయంతో కలుపుతుంది. జాతీయ మహిళా కమిషన్‌కు కూడా 14490 అనే హెల్ప్‌లైన్ ఉంది, అది ఆన్‌లైన్‌లో ఫిర్యాదులు కూడా తీసుకుంటుంది.'
    },
    consumer: {
      q: 'ఒక షాపు లేదా కంపెనీ నన్ను మోసం చేసింది. ఎక్కడ ఫిర్యాదు చేయాలి?',
      a: 'జాతీయ వినియోగదారుల హెల్ప్‌లైన్ 1915 కు కాల్ చేయండి (ఉచితం, ఉదయం 8 నుంచి రాత్రి 8 వరకు), 8800001915 కు WhatsApp మెసేజ్ పంపండి, లేదా consumerhelpline.gov.in లో ఫిర్యాదు చేయండి. వినియోగదారుల కమిషన్‌లో కేసు వేయాలంటే, e-Daakhil లో ఆన్‌లైన్‌లో వేయవచ్చు.'
    },
    summons: {
      q: 'నాకు కోర్టు సమన్లు వచ్చాయి. నేను ఏం చేయాలి?',
      a: 'ఒక నిర్దిష్ట తేదీన కోర్టుకు రావాలని సమన్లు చెబుతాయి. మీకు అర్హత ఉంటే, కేసు ఏ దశలోనైనా ఉచిత లాయర్‌ను పొందవచ్చు: 15100 కు కాల్ చేయండి లేదా మీ జిల్లా కోర్టులోని న్యాయ సేవల ఆఫీసుకు వెళ్లండి. మీ కేసును, దాని తదుపరి తేదీని eCourts వెబ్‌సైట్‌లో లేదా యాప్‌లో చూడవచ్చు.'
    },
    case_status: {
      q: 'నా కోర్టు కేసు స్థితి ఎలా చూడాలి?',
      a: 'services.ecourts.gov.in కు వెళ్లండి, లేదా eCourts Services యాప్ వాడండి. మీ 16 అంకెల CNR నంబర్ లేదా కేసు ఇతర వివరాలతో వెతకండి. SMS కూడా పంపవచ్చు: ECOURTS, ఒక స్పేస్, తర్వాత మీ CNR నంబర్ టైప్ చేసి 9766899899 కు పంపండి.'
    },
    lok_adalat: {
      q: 'లోక్ అదాలత్ అంటే ఏమిటి?',
      a: 'లోక్ అదాలత్ రెండు పక్షాల అంగీకారంతో కేసులను పరిష్కరిస్తుంది. ఇందులో కోర్టు ఫీజు ఉండదు. ఇప్పటికే కోర్టులో ఉన్న కేసు ఇక్కడ పరిష్కారమైతే, మీరు కట్టిన కోర్టు ఫీజు తిరిగి ఇస్తారు. దీని తీర్పు కోర్టు డిక్రీలాగే తుది నిర్ణయం, తప్పకుండా పాటించాల్సిందే. దీనిపై అప్పీల్ ఉండదు.'
    },
    rti: {
      q: 'RTI ఎలా దాఖలు చేయాలి?',
      a: 'కేంద్ర ప్రభుత్వ ఆఫీసుల కోసం rtionline.gov.in లో ఆన్‌లైన్‌లో దరఖాస్తు చేయండి. ఫీజు ₹10. మీరు దారిద్ర్య రేఖకు దిగువన ఉంటే ఫీజు లేదు (మీ BPL సర్టిఫికెట్ జత చేయండి). అధికారి 30 రోజుల్లో జవాబు ఇవ్వాలి. ఎవరి ప్రాణం లేదా స్వేచ్ఛకు సంబంధించిన విషయమైతే 48 గంటల్లో ఇవ్వాలి. 30 రోజుల్లో జవాబు రాకపోతే, తర్వాతి 30 రోజుల్లో ఉచితంగా మొదటి అప్పీల్ వేయవచ్చు.'
    },
    grievance: {
      q: 'ప్రభుత్వ ఆఫీసు నా పని చేయడం లేదు. ఎక్కడ ఫిర్యాదు చేయాలి?',
      a: 'pgportal.gov.in లోని CPGRAMS లో ఫిర్యాదు నమోదు చేయండి. ఇది రాత్రింబవళ్లు తెరిచే ఉంటుంది (దాని యాప్‌లో, UMANG లో కూడా ఉంది). 21 రోజుల్లో పరిష్కరించడం లక్ష్యం. RTI విషయాలు, కోర్టు కేసులు, మతపరమైన విషయాలు, ప్రభుత్వ ఉద్యోగుల సర్వీస్ విషయాలు ఇందులో తీసుకోరు.'
    }
  }
}
